export function formatTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0) {
        return `${hours} hr${hours > 1 ? 's' : ''} ${
            remainingMinutes > 0 ? remainingMinutes + ' mins' : ''
        }`;
    }

    return `${remainingMinutes} mins`;
}
